module.exports = __webpack_public_path__ + "static/media/phone.e4592cdb.png";